export const roleId = {
    teacher:2,
    editor:3,
    siteAdmin:1,
}
export const district = [
    {
        label: "中西區",
        value: '中西區',
    },
    {
        label: "香港東區",
        value: '香港東區',
    },
    {
        label: "離島區",
        value: '離島區',
    },
    {
        label: "九龍城區",
        value: '九龍城區',
    },
    {
        label: "葵青區",
        value: '葵青區',
    },
    {
        label: "觀塘區",
        value: '觀塘區',
    },
    {
        label: "香港南區",
        value: '香港南區',
    },
    {
        label: "西貢區",
        value: '西貢區',
    },
    {
        label: "沙田區",
        value: '沙田區',
    },
    {
        label: "深水埗區",
        value: '深水埗區',
    },
    {
        label: "北區",
        value: '北區',
    },
    {
        label: "大埔區",
        value: '大埔區',
    },
    {
        label: "荃灣區",
        value: '荃灣區',
    },
    {
        label: "屯門區",
        value: '屯門區',
    },
    {
        label: "灣仔區",
        value: '灣仔區',
    },
    {
        label: "黃大仙區",
        value: '黃大仙區',
    },
    {
        label: "油尖旺區",
        value: '油尖旺區',
    },
    {
        label: "元朗區",
        value: '元朗區',
    },
    {
        label: "中國內地",
        value: '中國內地',
    },
    {
        label: "海外",
        value: '海外',
    }
]
export const region = [
    {
        label: "香港島",
        value: '香港島',
    },
    {
        label: "九龍",
        value: '九龍',
    },
    {
        label: "新界",
        value: '新界',
    },
    {
        label: "澳門",
        value: '澳門',
    },
    {
        label: "廣州",
        value: '廣州',
    },
    {
        label: "新加坡",
        value: '新加坡',
    },
    {
        label: "列治文",
        value: '列治文',
    },
    {
        label: "溫哥華西區",
        value: '溫哥華西區',
    },
]
export const areaCode = [
    {
        label: "+852",
        value: '852',
    },
    {
        label: "+853",
        value: '853',
    },
    {
        label: "+86",
        value: '86',
    },
    {
        label: "+65",
        value: '65',
    },
    {
        label: "+1",
        value: '1',
    },
]
export const nation = [
    {
        label: "中國香港",
        value: '中國香港',
    },
    {
        label: "中國澳門",
        value: '中國澳門',
    },
    {
        label: "中國大陆",
        value: '中國大陆',
    },
    {
        label: "新加坡",
        value: '新加坡',
    },
    {
        label: "加拿大",
        value: '加拿大',
    },
]
export const gender = [
    {
        label: "女",
        value: 0,
    },
    {
        label: "男",
        value: 1,
    },
]
export const payStatus = [
    {
        label: "未付款",
        value: 0,
    },
    {
        label: "已付款",
        value: 1,
    },
]
export const scope = [
    {
        label: "第一部分",
        value: 0,
    },
    {
        label: "第二部分",
        value: 1,
    },
    {
        label: "第三部分",
        value: 2,
    },
  
]
export const scopeEn = [
    {
        label: "Numbers & Operations",
        value: 0,
    },
    {
        label: "Shapes & Measurement",
        value: 1,
    },
    {
        label: "Applications & Thinking",
        value: 2,
    },
  
]
export const unit = [
    {
        label: "講解",
        value: 0,
    },
    {
        label: "測驗",
        value: 1,
    },
]
export const grade = [
    {
        label: 'P1',
        value: 1,
    },
    {
        label: 'P2',
        value: 2,
    },
    {
        label: 'P3',
        value: 3,
    },
    {
        label: 'P4',
        value: 4,
    },
    {
        label: 'P5',
        value: 5,
    },
    {
        label: 'P6',
        value: 6,
    },
]
export const level = [
    {
        label: '※',
        value: 1,
    },
    {
        label: '※※',
        value: 2,
    },
    {
        label: '※※※',
        value: 3,
    },
    {
        label: '※※※※',
        value: 4,
    },
    {
        label: '※※※※※',
        value: 5,
    },
]
export const languages=[
    {
        label:'中文',
        value:0
    },
    {
        label:'英文',
        value:1
    },
]
export const paymentType=[
    {
        label:'網上付款',
        value:0
    },
    {
        label:'管理員開通',
        value:1
    },
    {
        label:'分校付款',
        value:2
    },
    {
        label:'升級',
        value:3
    },
    {
        label:'其他',
        value:4
    },
]
export const rolesName=[
    {
        label:'Site Admin',
        value:1
    },
    {
        label:'Teacher',
        value:2
    },
]